import { AiFillSafetyCertificate } from "react-icons/ai";
import { BiMessageAltCheck } from "react-icons/bi";
import { GiFlatbedCovered, GiHeadphones } from "react-icons/gi";
// import "../Components/card/card.css"

export const simpleCardDataOne = [
  {
    icon: <GiFlatbedCovered id="simpleCardIcons" />,
    text: "Worldwide Delivery",
  },
  {
    icon: <BiMessageAltCheck id="simpleCardIcons" />,
    text: "Safe Payment",
  },
];

export const simpleCardDataTwo = [
  {
    icon: <AiFillSafetyCertificate id="simpleCardIcons" />,
    text: "Shop With Confidence",
  },
  {
    icon: <GiHeadphones id="simpleCardIcons" />,
    text: "24/7 Support",
  },
];
